import { useTracking } from '@vfit/shared/data-access';
import { useEffect } from 'react';
import { getUserInfo, getTagging } from '../../../../checkout.utils';
import { useCheckout } from '../../../../../iBuyMobile.context';
import { useQueryClient } from 'react-query';

export const useVoucherSuccessCardTagging = () => {
  const { voucher } = useCheckout();
  const queryClient = useQueryClient();
  const taggingMobile = getTagging('voucher typ', 'mobile', queryClient);
  const dataLayer = {
    event: ['checkout_step8.3'],
    event_label: 'voucher applied',
    opts: taggingMobile?.opts,
    cartProduct: taggingMobile?.trackingProduct,
    pageProduct: taggingMobile?.pageProductsInfo,
    product_discount_value: voucher?.validateVoucher?.data?.finalPrice,
    transaction_coupon_code: voucher?.voucherId || '',
    visitorTrackingOpts: getUserInfo(),
  };
  const { trackWithNewDatalayer } = useTracking({
    ...dataLayer,
    disableInitialTrack: true,
  });

  useEffect(() => {
    if (voucher?.shoppingCart?.isSuccess) {
      trackWithNewDatalayer({
        ...dataLayer,
      });
    }
  }, [voucher]);

  return null;
};
